"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _templateObject;
const _excluded = ["children", "styles", "width", "margin", "padding", "type", "inverse", "className", "wrapperTag"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var BadgeType = /*#__PURE__*/function (BadgeType) {
  BadgeType["Primary"] = "primary";
  BadgeType["Success"] = "success";
  BadgeType["Error"] = "error";
  BadgeType["Warning"] = "warning";
  BadgeType["Ghost"] = "ghost";
  return BadgeType;
}(BadgeType || {});
const defaultProps = {
  children: '',
  type: BadgeType.Primary,
  inverse: false,
  color: '',
  width: 'fit-content',
  className: '',
  wrapperTag: 'div'
};
function Badge(props) {
  const _defaultProps$props = _objectSpread(_objectSpread({}, defaultProps), props),
    {
      children,
      styles,
      width,
      margin,
      padding,
      type,
      inverse,
      className,
      wrapperTag
    } = _defaultProps$props,
    restOfProps = _objectWithoutProperties(_defaultProps$props, _excluded);
  return /*#__PURE__*/_react.default.createElement(Container.withComponent(wrapperTag), _objectSpread({
    styles,
    width,
    margin,
    padding,
    type,
    inverse,
    className
  }, restOfProps), children);
}
const Container = _styled.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: 5px;\n  width: ", ";\n  margin: ", ";\n  padding: ", ";\n\n  ", "\n\n  ", "\n"])), _ref => {
  let {
    width
  } = _ref;
  return width || 'fit-content';
}, _ref2 => {
  let {
    margin
  } = _ref2;
  return margin || 0;
}, _ref3 => {
  let {
    padding
  } = _ref3;
  return padding || '3px 5px';
}, _ref4 => {
  let {
    type,
    inverse,
    theme
  } = _ref4;
  const {
    colors
  } = theme;
  let styles = "\n      font-size: 14px;\n      text-align: center;\n      font-weight: 700;\n    ";
  if (type === BadgeType.Ghost) {
    styles += "\n        color: ".concat(colors.FONT.DESCRIPTION, ";\n        background-color: ").concat(inverse ? colors.NEUTRAL.TRANSPARENT : colors.NEUTRAL.SELECTED, ";\n        border: 1px solid ").concat(colors.NEUTRAL.SELECTED, ";\n    ");
  } else {
    var _colors$MAIN;
    const mainColor = (_colors$MAIN = colors.MAIN) === null || _colors$MAIN === void 0 ? void 0 : _colors$MAIN[String(type).toUpperCase()];
    styles += "\n        background-color: ".concat(inverse ? colors.NEUTRAL.TRANSPARENT : mainColor, ";\n        color: ").concat(inverse ? mainColor : colors.FONT.CONTRAST, ";\n        border: 1px solid ").concat(mainColor, ";\n      ");
  }
  return styles;
}, _ref5 => {
  let {
    styles
  } = _ref5;
  return styles;
});
var _default = exports.default = Badge;